// The words the theatre screens share (docs/plans/phase2-theatre.md §6). One name for each
// state and step everywhere.
import type { ChecklistPhase, TheatreCaseView, TheatreListCase } from '@wodi/shared';
import type { TagState } from '@wodi/ui';

import { ApiError } from '../api/client.ts';

export const STATUS_TAGS: Record<TheatreCaseView['status'], [string, TagState]> = {
  booked: ['Booked', 'pending'],
  in_theatre: ['In theatre', 'active'],
  completed: ['Completed', 'done'],
  cancelled: ['Cancelled', 'neutral'],
};

export const PHASE_WORDS: Record<ChecklistPhase, string> = {
  pre_op: 'Pre-op checklist',
  sign_in: 'Sign in',
  time_out: 'Time out',
  sign_out: 'Sign out',
};

/** The button that records each phase. */
export const PHASE_ACTIONS: Record<ChecklistPhase, string> = {
  pre_op: 'Record pre-op checklist',
  sign_in: 'Record sign in',
  time_out: 'Record time out',
  sign_out: 'Record sign out',
};

export const ANSWER_WORDS = { yes: 'Yes', no: 'No', not_applicable: 'Not applicable' } as const;

export const URGENCY_WORDS = { elective: 'Elective', emergency: 'Emergency' } as const;

/** Where the checklist has got to, in a few words, for the list. */
export function progressText(c: Pick<TheatreListCase, 'phasesDone' | 'status' | 'noteSigned'>) {
  if (c.status === 'cancelled') return 'Cancelled';
  const last = c.phasesDone.at(-1);
  const steps = last === undefined ? 'Checklist not started' : `${PHASE_WORDS[last]} recorded`;
  return c.status === 'completed' && !c.noteSigned ? `${steps}; note not signed` : steps;
}

export function errorText(error: unknown, fallback: string): string {
  return error instanceof ApiError ? error.message : fallback;
}
